import { showErrorSnack } from "../../../../../ui-components/utils";
import Network from "../../../../../services/Network";
import { COUNTRIES, CITIES } from "../../../../../utils/endpoints";

export const fetchLocation = resolve => navigator.geolocation.getCurrentPosition(
    position => resolve({ lat: position.coords.latitude, lng: position.coords.longitude }),
    error => {
        const messages = {
            0: 'Could not fetch Location. Please use the Search', 1: 'Location Permission has not been given. Please enable in your browser settings',
            2: 'Position Unavailable. Please use the Search', 3: 'Timed out while fetching Location. Please use the Search'
        };
        showErrorSnack(messages[error.code]);
        resolve(null);
    }
);

export const fetchCountries = (resolve, reject) => Network.GET(COUNTRIES, null, null,
    response => resolve(response.countries.slice().sort((a, b) => a.name > b.name)),
    reject
);

export const fetchCities = (id, resolve, reject) => Network.GET(CITIES, { parent_geo_ids: id }, null,
    response => resolve(response.cities.slice().sort((a, b) => a.name > b.name)),
    reject
);